import { setRiskGapAnswer } from './utils/setRiskGapAnswer';
import { createUseUpdateGap, UpdateGapBaseParams } from './useUpdateGap';

export interface UpdateRiskGapParams extends UpdateGapBaseParams {
    submission_answer?: null;
}

export const useUpdateRiskGap = createUseUpdateGap<UpdateRiskGapParams, RiskGapType>({
    urlPrefix: '/api/risk-gaps/',
    gapProp: 'risk_gaps',
    transform: setRiskGapAnswer,
});
